<template>
    <form @submit="persistSection">

      <fieldset class="form-group">
        <legend>Titre du podcast</legend>
        <label class="sr-only" for="titlePodcast">Titre du podcast</label>
        <input id="titlePodcast" class="form-control"
                  v-model="sectionDatas.titlePodcast.datas" :maxlength="60">
        <div class="char-count" v-text="sectionDatas.titlePodcast.datas ? sectionDatas.titlePodcast.datas.length + '/60' : 0 + '/60'"></div>
      </fieldset>

        <fieldset class="form-group">
            <legend>Description Podcast</legend>
            <label class="sr-only" for="descriptionPodcast">Description podcast</label>
            <textarea id="descriptionPodcast" class="form-control"
                      v-model="sectionDatas.descriptionPodcast.datas" :maxlength="600"></textarea>
            <div class="char-count" v-text="sectionDatas.descriptionPodcast.datas ? sectionDatas.descriptionPodcast.datas.length + '/600' : 0 + '/600'"></div>
        </fieldset>

        <fieldset class="form-group">
            <legend>Tags</legend>
            <div class="row">
                <div class="col-sm-6">
                    <label class="sr-only" for="tagPrincipal">tag principal</label>
                    <i>Tag principal, un seul mot clé, obligatoire</i>
                    <input type="text" id="tagPrincipal" class="form-control" v-model="sectionDatas.tagPrincipal.datas"
                           placeholder="tag principal">
                </div>
                <div class="col-sm-6">
                    <label class="sr-only" for="tagSecondaire">tag secondaire</label>
                    <i>Tag secondaire, un seul mot clé, obligatoire</i>
                    <input type="text" id="tagSecondaire" class="form-control" v-model="sectionDatas.tagSecondaire.datas"
                           placeholder="tag secondaire">
                </div>
                <div class="col-12 mt-2">
                  <label class="sr-only" for="tagsComplementaires">tags complémentaires</label>
                  <i>Tags complémentaires, plusieurs mots clés possibles, séparés par des virgules</i>
                  <input type="text" id="tagsComplementaires" class="form-control" v-model="sectionDatas.tagsComplementaires.datas"
                         placeholder="tags complémentaires">
                </div>
            </div>
        </fieldset>

        <fieldset class="form-group">
            <legend>Sous-catégorie</legend>
            <b-form-radio-group v-model="sectionDatas.sousCategorieWPId.datas" name="sousCat">
                <b-form-radio value="62">Arts vivants</b-form-radio>
                <b-form-radio value="55">Théâtre</b-form-radio>
                <b-form-radio value="68">Expo</b-form-radio>
                <b-form-radio value="44">Litterature</b-form-radio>
                <b-form-radio value="909">BD</b-form-radio>
                <b-form-radio value="63">Cinema</b-form-radio>
                <b-form-radio value="70">Geek</b-form-radio>
                <b-form-radio value="53">Série</b-form-radio>
                <b-form-radio value="64">Concert</b-form-radio>
                <b-form-radio value="58">Vostok Session</b-form-radio>
                <b-form-radio value="">Aucune</b-form-radio>
            </b-form-radio-group>
        </fieldset>

        <fieldset class="form-group">
            <legend>Auteur</legend>
            <label class="sr-only" for="auteur">Auteur</label>
            <select id="auteur" class="form-control" v-model="sectionDatas.auteur.datas">
                <option v-for="auteur in availableAuteurs" v-bind:value="{ id: auteur.id, name: auteur.name }">
                    {{auteur.name}}
                </option>
            </select>
        </fieldset>

        <fieldset class="form-group">
          <upload-file v-if="showUpload" :type="'image'" :fileId="sectionDatas.image.datas" :formats="['jpeg','jpg']"
                       :types="['image/jpeg', 'image/png']"
                       v-on:push-file="pushFile"></upload-file>
        </fieldset>

        <fieldset class="form-group">
            <legend>Première diffusion antenne</legend>
            <Datepicker aria-label="dateDiffusion" aria-describedby="dateDiffusion"
                        id="dateDiffusion" v-model="sectionDatas.dateDiffusion.datas" :clear-button="true"></Datepicker>
        </fieldset>


        <fieldset class="form-group">
          <upload-file v-if="showUpload" :type="'audio'" :fileId="sectionDatas.audio.datas" :formats="['mp3']"
                       :types="['audio/mpeg3', 'audio/mpeg', 'audio/x-mpeg-3', 'audio/mp3']"
                       v-on:push-file="pushFile"></upload-file>
        </fieldset>

        <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Valider cette étape</button>

    </form>
</template>

<script>

  import UploadFile from './UploadFile'
  import Datepicker from 'vuejs-datepicker'
  import bdd from "../../api/bdd"

  export default {

    name: 'PodcastForm',

    props: {
      subject: Object,
      editPending: false
    },

    components: {
      Datepicker,
      UploadFile
    },

    data() {
      return {
        sectionName: 'podcast',
        sectionDatas: {
          titlePodcast: {
            name: 'titre podcast',
            datas: ''
          },
          descriptionPodcast: {
            name: 'description podcast',
            datas: ''
          },
          audio: {
            name: 'fichier audio',
            datas: null,
          },
          image: {
            name: 'fichier image',
            datas: null
          },
          dateDiffusion: {
            name: 'Première diffusion antenne',
            datas: null,
            trelloDatas: ''
          },
          tagPrincipal: {
            name: 'tag principal',
            datas: null
          },
          tagSecondaire: {
            name: 'tag principal',
            datas: null
          },
          tagsComplementaires: {
            name: 'tags complémentaires',
            datas: null
          },
          sousCategorieWPId: {
            name: 'Sous catégorie Worpdres',
            datas: null
          },
          auteur: {
            name: 'auteur',
            datas: {
              id: null,
              name: ''
            }
          },
        },
        showUpload: false,
        availableAuteurs: [],
      }
    },

    mounted() {
      this.sectionDatas.titlePodcast.datas = this.subject.titlePodcast
      this.sectionDatas.descriptionPodcast.datas = this.subject.descriptionPodcast
      this.sectionDatas.audio.datas = this.subject.audio
      this.sectionDatas.image.datas = this.subject.image
      this.sectionDatas.tagPrincipal.datas = this.subject.tagPrincipal
      this.sectionDatas.tagSecondaire.datas = this.subject.tagSecondaire
      this.sectionDatas.tagsComplementaires.datas = this.subject.tagsComplementaires
      this.sectionDatas.dateDiffusion.datas = this.subject.dateDiffusion
      this.sectionDatas.sousCategorieWPId.datas = this.subject.sousCategorieWPId
      this.formatDateDiffusion()
      bdd.getAvailableLabel('auteurs')
        .then(auteurs => {
          this.availableAuteurs = auteurs
          this.availableAuteurs.sort((a, b) => (a.name.localeCompare(b.name)))
          console.log('auteurs disponibles : ', this.availableAuteurs)
          let index = this.subject.auteur.lastIndexOf('/') + 1
          let auteurCleanId = this.subject.auteur.substr(index)
          for (let i = 0; i < this.availableAuteurs.length; i++) {
            if (auteurCleanId === this.availableAuteurs[i].id) {
              this.sectionDatas.auteur.datas.id = this.availableAuteurs[i].id
              this.sectionDatas.auteur.datas.name = this.availableAuteurs[i].name
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
      this.$emit('push-section', this.sectionDatas, this.sectionName)
      this.showUpload = true
    },

    methods: {
      persistSection: function (e) {
        e.preventDefault()
        this.formatDateDiffusion()
        this.$emit('push-edit', this.sectionDatas, this.sectionName)
      },
      pushFile: function (type, id, url) {
        this.sectionDatas[type].datas = id
        this.sectionDatas[type].trelloDatas = url
      },
      formatDateDiffusion: function () {
        if (this.sectionDatas.dateDiffusion.datas !== null ){
          let date = new Date(this.sectionDatas.dateDiffusion.datas)
          this.sectionDatas.dateDiffusion.trelloDatas = date.toLocaleDateString('fr-FR')
        } else {
          this.sectionDatas.dateDiffusion.trelloDatas = ''
        }
      }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/EditSub/PodcastForm.vue